import { render, staticRenderFns } from "./PanelHeader.vue?vue&type=template&id=17b5040c&scoped=true"
import script from "./PanelHeader.vue?vue&type=script&lang=js"
export * from "./PanelHeader.vue?vue&type=script&lang=js"
import style0 from "./PanelHeader.vue?vue&type=style&index=0&id=17b5040c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b5040c",
  null
  
)

export default component.exports